<app-radio-paginated [searchSettings]="searchSettings"
                     [loaderId]="loaderId"
                     [totalCount]="totalCount"
                     [filter]="filter"
                     [dataToView]="dataToView"
                     (nextData)="getNextData($event)">
</app-radio-paginated>
